import { useState } from "react";
import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FaRegEyeSlash } from "react-icons/fa6";
import { InputGroup } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { FaRegEye } from "react-icons/fa6";
import { Formik } from "formik";
import { ChangePasswordValidator } from "../../validation/validator";
import {
  changePassword,
} from "../../service/apis/auth.api";
import { ButtonLoader } from "../../common/Loader/loader";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import EmployerHeaderScreen from "../../component/layout/employerheader";
import EmployerSidebarScreen from "../../component/layout/employer-sidebar";
// import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { showError, showSuccess } from "../../utils/Common";
import { updateNotificationSettings } from "../../store/auth.store";
import { AppDispatch } from "../../store/store"; // Ensure this import exists


const JobseekerSettingsScreen = () => {
  const [state, setState] = useState({
    password_old: "",
    password_new: "",
    confirm_password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isOldPasswordVisible, setIsOldPasswordVisible] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
  // const dispatch = useDispatch();
  const dispatch = useDispatch<AppDispatch>(); // Type the dispatch function


  const { user } = useSelector((state: RootState) => state.authSlice);
  // const [NavigateTo] = useCustomNavigate();
  // console.log(user?.notification,88787);

  const [receiveNotification, setReceiveNotification] = useState(user?.notification);

  const handleFormSubmit = async (values: any, { resetForm }: any) => {
    if (values) {
      try {
        setIsLoading(true);
        // delete values.confirm_password;
        const { password_old, password_new } = values;
        const payload = {
          password_old,
          password_new,
        };
        const response = await changePassword(payload);
        if (response?.status === 200) {
          showSuccess(response?.message);
          resetForm();
          setState({
            password_old: "",
            password_new: "",
            confirm_password: "",
          });
        }
      } catch (err: any) {
        // showError(err?.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  // const handleNotification = async (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   try {

  //     // const response = await notificationSettings(payload);
  //     // console.log("payload", payload);
  //     const payload = !receiveNotification;
  //     const response = dispatch(updateNotificationSettings(payload));

  //     setReceiveNotification(!receiveNotification);
  //   } catch (err: any) {
  //     showError(err?.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleNotification = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsLoading(true);
    try {
      const newNotificationStatus = !receiveNotification;
      const resultAction = await dispatch(updateNotificationSettings(newNotificationStatus));

      if (updateNotificationSettings.fulfilled.match(resultAction)) {
        setReceiveNotification(newNotificationStatus);
        showSuccess("Settings Updated!");
      } else {
        throw new Error("Failed to update notification settings");
      }
    } catch (err) {
      showError(err instanceof Error ? err.message : "An unknown error occurred");
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                {/* <SidebarScreen /> */}
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && <AgentSidebarScreen />}
                {user && user?.role === "employer" && <EmployerSidebarScreen />}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && <AgentTopHeadScreen />}
                {user && user?.role === "employer" && <EmployerHeaderScreen />}
                {/* <TopHeadScreen /> */}
                <div className="profileJoblisting-holder rightInnerScroll">
                  <div className="row">
                    <div className="col-lg-12 filterHolder pt-3 mb-4">
                      <div className="filterResults">
                        <div className="title">
                          <h2>Settings</h2>
                        </div>
                        <Formik
                          enableReinitialize
                          initialValues={state}
                          validationSchema={ChangePasswordValidator}
                          onSubmit={handleFormSubmit}
                        >
                          {({
                            values,
                            handleChange,
                            handleBlur,
                            touched,
                            errors,
                            isSubmitting,
                            handleSubmit,
                          }) => (
                            <Form onSubmit={handleSubmit}>
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="nPtabs-holder">
                                    <Tabs
                                      defaultActiveKey="Notification"
                                      transition={false}
                                      id="noanim-tab-example"
                                      className="mb-3"
                                    >
                                      <Tab
                                        eventKey="Notification"
                                        title="Notification"
                                      >
                                        <div className="nPtabs-info">
                                          <h3>Notification Settings</h3>
                                          <p>
                                            We may still send you important
                                            notifications about your account
                                            outside of your notification
                                            settings.
                                          </p>
                                          <h3>Receive Notifications</h3>
                                          <div className="check-flex">
                                            <p>
                                              Get notified about important
                                              updates such as job application
                                              changes, new job listings,
                                              interview reminders, and
                                              immigration status updates.
                                            </p>
                                            <span className="form-switch">
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                onChange={(e) =>
                                                  handleNotification(e)
                                                }
                                                checked={receiveNotification}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </Tab>
                                      <Tab eventKey="Password" title="Password">
                                        <div className="nPtabs-info">
                                          <h3> Settings</h3>
                                          <p>
                                            Manage your account password to keep
                                            your information secure.
                                          </p>
                                          <div className="row">
                                            <div className="col-lg-12">
                                              <Form.Label>
                                                Old Password
                                              </Form.Label>
                                              <InputGroup className="mb-3 w-50">
                                                <Form.Control
                                                  aria-describedby="basic-addon1"
                                                  type={
                                                    isOldPasswordVisible
                                                      ? "text"
                                                      : "password"
                                                  }
                                                  name="password_old"
                                                  placeholder="Enter your old password"
                                                  onBlur={handleBlur}
                                                  onChange={(e) =>
                                                    handleChange(e)
                                                  }
                                                   style={{ backgroundImage: "none" }}
                                                  value={values?.password_old}
                                                  isInvalid={
                                                    touched?.password_old &&
                                                    !!errors.password_old
                                                  }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  {touched?.password_old &&
                                                    errors.password_old}
                                                </Form.Control.Feedback>
                                                <InputGroup.Text id="basic-addon1">
                                                  <div
                                                    style={{ zIndex: 6 }}
                                                    className={`eye-icon ${isOldPasswordVisible
                                                      ? "red"
                                                      : ""
                                                      }`}
                                                  >
                                                    {isOldPasswordVisible ? (
                                                      <FaRegEye
                                                        onClick={() =>
                                                          setIsOldPasswordVisible(
                                                            false
                                                          )
                                                        }
                                                      />
                                                    ) : (
                                                      <FaRegEyeSlash
                                                        onClick={() =>
                                                          setIsOldPasswordVisible(
                                                            true
                                                          )
                                                        }
                                                      />
                                                    )}
                                                  </div>
                                                  {/* <FaRegEyeSlash /> */}
                                                </InputGroup.Text>
                                              </InputGroup>
                                              {/* <div className="text-right w-50">
                                                <a className='forgotPassword' onClick={handleClick}>
                                                  Forgot Old Password?
                                                </a>
                                              </div> */}
                                            </div>
                                            <div className="col-lg-12">
                                              <Form.Label>
                                                New Password
                                              </Form.Label>
                                              <InputGroup className="mb-3 w-50">
                                                <Form.Control
                                                  aria-describedby="basic-addon2"
                                                  type={
                                                    isPasswordVisible
                                                      ? "text"
                                                      : "password"
                                                  }
                                                  name="password_new"
                                                  placeholder="Enter your new password"
                                                  onBlur={handleBlur}
                                                  onChange={(e) =>
                                                    handleChange(e)
                                                  }
                                                  style={{ backgroundImage: "none" }}
                                                  value={values.password_new}
                                                  isInvalid={
                                                    touched.password_new &&
                                                    !!errors.password_new
                                                  }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  {touched.password_new &&
                                                    errors.password_new}
                                                </Form.Control.Feedback>
                                                <InputGroup.Text id="basic-addon2">
                                                  <div
                                                    style={{ zIndex: 6 }}
                                                    className={`eye-icon ${isPasswordVisible
                                                      ? "red"
                                                      : ""
                                                      }`}
                                                  >
                                                    {isPasswordVisible ? (
                                                      <FaRegEye
                                                        onClick={() =>
                                                          setIsPasswordVisible(
                                                            false
                                                          )
                                                        }
                                                      />
                                                    ) : (
                                                      <FaRegEyeSlash
                                                        onClick={() =>
                                                          setIsPasswordVisible(
                                                            true
                                                          )
                                                        }
                                                      />
                                                    )}
                                                  </div>
                                                  {/* <FaRegEyeSlash /> */}
                                                </InputGroup.Text>
                                              </InputGroup>
                                            </div>
                                            <div className="col-lg-12">
                                              <Form.Label>
                                                Confirm Password
                                              </Form.Label>
                                              <InputGroup className="mb-3 w-50">
                                                <Form.Control
                                                  aria-describedby="basic-addon3"
                                                  type={
                                                    isConfirmPasswordVisible
                                                      ? "text"
                                                      : "password"
                                                  }
                                                  name="confirm_password"
                                                  placeholder="Enter your confirm password"
                                                  onBlur={handleBlur}
                                                  onChange={(e) =>
                                                    handleChange(e)
                                                  }
                                                  style={{ backgroundImage: "none" }}
                                                  value={
                                                    values.confirm_password
                                                  }
                                                  isInvalid={
                                                    touched.confirm_password &&
                                                    !!errors.confirm_password
                                                  }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                  {touched.confirm_password &&
                                                    errors.confirm_password}
                                                </Form.Control.Feedback>
                                                <InputGroup.Text id="basic-addon3">
                                                  <div
                                                    style={{ zIndex: 6 }}
                                                    className={`eye-icon ${isConfirmPasswordVisible
                                                      ? "red"
                                                      : ""
                                                      }`}
                                                  >
                                                    {isConfirmPasswordVisible ? (
                                                      <FaRegEye
                                                        onClick={() =>
                                                          setIsConfirmPasswordVisible(
                                                            false
                                                          )
                                                        }
                                                      />
                                                    ) : (
                                                      <FaRegEyeSlash
                                                        onClick={() =>
                                                          setIsConfirmPasswordVisible(
                                                            true
                                                          )
                                                        }
                                                      />
                                                    )}
                                                  </div>
                                                  {/* <FaRegEyeSlash /> */}
                                                </InputGroup.Text>
                                              </InputGroup>
                                            </div>
                                            <div className="col-lg-12">
                                              <div className="form-group">
                                                <Button
                                                  className="btn"
                                                  type="submit"
                                                >
                                                  {isLoading ? (
                                                    <ButtonLoader />
                                                  ) : (
                                                    "Save Changes"
                                                  )}
                                                </Button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </Tab>
                                    </Tabs>
                                  </div>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />
    </>
  );
};
export default JobseekerSettingsScreen;
